import RouteMappingCard from "./RouteMappingCard";
import { withStyles, Checkbox } from "@material-ui/core";
import Tooltip from "../../../../../common/StyledToolTip";

const styles = (theme) => ({
  checkBox: {
    padding: 0,
    marginRight: 12,
    alignSelf: "flex-start",
    color: theme.iconColor,
  },
  cardContainer: {
    display: "flex",
  },
});
const RouteMappingCardList = ({
  classes,
  checkBoxList,
  onChange,
  openForm,
  selectedFeatureIds,
  selectedFeatureIdsOnMap,
  forwardRef,
  selectPolygonsOnMap,
  showDoorNumber
}) => {
  return (
    <div ref={forwardRef}>
      {checkBoxList.map((item, index) => (
        <div
          id={item.id}
          className={classes.cardContainer}
          key={`${item.id}_${index}`}
        >
          <Tooltip
            title={
              item.isChecked
                ? "Hide this route mapping area on map"
                : "Show this route mapping area on map"
            }
          >
            <Checkbox
              color="primary"
              className={classes.checkBox}
              checked={item.isChecked}
              name={item.id}
              onChange={onChange}
            />
          </Tooltip>
          <RouteMappingCard
            isSelectedOnMap={selectedFeatureIdsOnMap?.includes(item.id)}
            isEditable={
              selectedFeatureIds ? selectedFeatureIds?.includes(item.id) : true
            }
            openForm={openForm}
            data={item.data}
            selectPolygonOnMap={selectPolygonsOnMap}
            showDoorNumber={showDoorNumber}
          />
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(RouteMappingCardList);
